<template>
	<v-dialog v-model="dialog" max-width="400px">
		<v-card>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">見積情報の更新</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<v-card-text class="pa-2">
				<v-form ref="form" lazy-validation>
					<v-row class="d-flex flex-wrap justify-center" no-gutters>
						<v-text-field
							type="date"
							v-model="quote_request.answer_date"
							class="mt-2 mx-1"
							label="回答日"
							outlined
							dense
						/>
						<v-select
							v-model="quote_request.status_type"
							:items="statusTypes"
							item-text="name"
							item-value="value"
							label="状態"
							class="mt-2 mx-1"
							outlined
							dense
						/>
						<v-text-field
							type="number"
							v-model="logi_quote.price"
							class="mt-2 mx-1"
							label="金額(単価)"
							outlined
							dense
						/>
						<v-text-field
							type="number"
							v-model="quote_request.quote_expiration_period"
							class="mt-2 mx-1"
							label="有効期限(日数)"
							outlined
							dense
						/>
					</v-row>
					<v-row class="d-flex flex-wrap justify-center" no-gutters> </v-row>
					<v-btn
						class="ma-2 pa-2 mt-4"
						:disabled="!logi_quote.price"
						color="primary"
						@click="updateQuote()"
						>編集を保存</v-btn
					>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-row no-gutters> </v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import moment from "moment"
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import FunctionTitle from "../../shared/FunctionTitle.vue"
import CommonFlame from "../../shared/CommonFlame.vue"

export default {
	props: {
		text: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			dialog: false,
			newCarModelName: "",
			statusTypes: [
				{ name: "依頼済み", value: "sent" },
				{ name: "回答取得済", value: "answered" },
			],
			quoteRequestId: "",
			quote_request: {
				answer_date: "",
				status_type: "",
				quote_expiration_period: "",
			},
			logi_quote: {
				price: "",
			},
		}
	},
	methods: {
		openDialog(record) {
			this.dialog = true
			this.quoteRequestId = record.id
			this.quote_request.answer_date = record.answer_date
			this.quote_request.status_type = record.status_type
			this.logi_quote.price = record.logi_quote.price
			this.quote_request.quote_expiration_period = record.quote_expiration_period
		},
		updateQuote() {
			const headers = authenticate.setHeader()
			var formData = new FormData()
			formData.set("quote_request", JSON.stringify(this.quote_request))
			formData.set("logi_quote", JSON.stringify(this.logi_quote))
			axios
				.put("/erp/v1/logi_quotes/" + this.quoteRequestId, formData, { headers })
				.then((res) => {
					this.$emit("reloadIndex")
					this.dialog = false
					this.$store.dispatch("setFlash", {
						text: "更新しました",
						type: "notice",
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	computed: {},
}
</script>

<style lang="scss" scoped>
.v-input--selection-controls {
	margin-top: 0;
}
</style>
